import { ColorPickerAction } from './color-picker.types';

export const COLOR_PICKER_CHANGE_COLOR = 'COLOR_PICKER_CHANGE_COLOR';

export function changeColor(color: string): ColorPickerAction {
	return {
		type: COLOR_PICKER_CHANGE_COLOR,
		payload: color
	};
}
